var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCursor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(-157.795 -75.031)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M-6973.7,2803.531v18h18v-18Z",
    transform: "translate(7132 -2728)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_67",
    "data-name": "Path 67",
    transform: "translate(7152 -2726)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-6993.793,2801.8l6.016,18,3.361-8.679,8.623-4.222Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -6992.2451171875 2803.277587890625 L -6987.7080078125 2816.852294921875 L -6985.3486328125 2810.759521484375 L -6985.20703125 2810.39453125 L -6984.85595703125 2810.222412109375 L -6978.57861328125 2807.148681640625 L -6992.2451171875 2803.277587890625 M -6993.79345703125 2801.7998046875 L -6975.79345703125 2806.898193359375 L -6984.416015625 2811.12060546875 L -6987.77734375 2819.7998046875 L -6993.79345703125 2801.7998046875 Z",
    stroke: "none",
    fill: "#1a244f"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursor);
export default __webpack_public_path__ + "static/media/cursor.50f0f06e.svg";
export { ForwardRef as ReactComponent };